import './footer.css';
import "../../../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <div className='footer'>
      {t("footer:copyright")}
    </div>
  );
}